export const NEWS_QUANTITY_A = 3;
export const NEWS_QUANTITY_B = 5;
export const SMI2_URL = 'https://smi2.ru/data/js/90247.json';
